<template>
    <div class="container-fluid">
        <Breadcrumb title="Add SMTP Relay" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit SMTP Relay #' + id" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card" v-if="!id">
                    <div class="card-body">
                        <div class="form-group" v-if="uploadingFiles.length">
                            <h5>Now uploading files:</h5>
                            <div v-for="(list, index) in uploadingFiles" :key="index">
                                <h3 class="mb-1 mt-3" style="font-size:18px;">
                                    {{list.label}}
                                    <span style="float:right;">{{list.completion}}</span>
                                </h3>
                                <div class="progress-bar bg-info" role="progressbar"
                                     v-bind:style="{width: list.completion, height: '3px'}"
                                     aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-0">
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="uploadCardView = true">
                                <i class="fas fa-upload"></i>
                                Upload a list
                            </button>
                        </div>
                    </div>
                </div>
                <transition name="bounce">
                    <div class="card" v-if="!id" v-show="uploadCardView" :key="$route.fullPath">
                        <div class="card-body">
                            <button type="button" class="close" aria-label="Close" @click="uploadCardView = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div>
                                <div class="form-group">
                                    <h4>Upload a list of Smtp Relays</h4>
                                    <small class="form-text text-muted mt-0">
                                        <br/>
                                        Header is required. Field separator is comma. 'Active' field is
                                        optional(default 'true'). Example:<br/>
                                        account,password,senderEmail,active<br/>
                                        ivanov,qwerty,ivanov@server.net,true<br/>
                                        johnson,asdfg,johnson@mail.net,false<br/>
                                    </small>
                                </div>
                                <div class="form-group text-left">
                                    <label>Select Relay Owner</label>
                                    <treeselect placeholder="Select User"
                                                v-model="owner"
                                                :multiple="false"
                                                :options="userList"
                                                :load-options="loadUserList"
                                                value-format="object"
                                                @input="ownerSelected"
                                    />
                                </div>
                                <div class="form-group text-left">
                                    <label>Select Smtp Server</label>
                                    <treeselect placeholder="Select Server"
                                                v-model="server"
                                                :multiple="false"
                                                :options="serverList"
                                                value-format="object"
                                    />
                                </div>
                                <div class="form-group text-left">
                                    <label>Select Relay Group</label>
                                    <treeselect placeholder="Select Group"
                                                v-model="group"
                                                :multiple="false"
                                                :options="groupList"
                                                value-format="object"
                                    />
                                </div>
                                <div class="form-group text-left">
                                    <label for="relays">Select Relays file</label>
                                    <input type="file" id="relays" accept="text/csv" class="w-100"/>
                                </div>
                                <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                        @click="listUpload">
                                    <i class="fas fa-upload"></i>
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="card">
                    <div class="card-body">
                        <SmtpRelayForm :id="id" @hidePreloader="hidePreloader"></SmtpRelayForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import SmtpRelayForm from './forms/SmtpRelayForm';
    import Breadcrumb from '../components/Breadcrumb';
    import SmtpRelayService from '../services/SmtpRelayService';
    import Swal from 'sweetalert2';
    import Treeselect from '@riophae/vue-treeselect';
    import UploadFileService from '../services/UploadFileService';
    import SmtpServerService from '../services/SmtpServerService';
    import SmtpRelayGroupService from '../services/SmtpRelayGroupService';
    import config from '../config';
    import {mapGetters} from 'vuex';
    import {FileType} from '../constants';
    import UserService from '../services/UserService';

    export default {
        name: 'SmtpRelay',
        props: ['id'],
        components: {
            Preloader, SmtpRelayForm, Breadcrumb, Treeselect
        },
        data() {
            return {
                loading: false,
                waiting: null,
                uploadCardView: false,
                uploadingFiles: [],
                serverList: [],
                groupList: [],
                userList: null,
                server: null,
                group: null,
                owner: null
            }
        },
        mounted() {
            if (this.id) {
                this.loading = true;
            } else {
                this.getUploadingFiles();
                this.listUploadProgress();
            }
        },
        computed: {
            ...mapGetters({mercureListen: 'listen'})
        },
        methods: {
            hidePreloader(value) {
                this.loading = value;
            },
            getUploadingFiles() {
                UploadFileService.getFiles(FileType['SMTP_RELAYS']).then(response => {
                    if (response.status === 200) {
                        this.uploadingFiles = response.data['hydra:member'].map(file => {
                            return {id: file.id, label: file.originalName, completion: '0%'}
                        });
                    }
                });
            },
            listUploadProgress() {
                if (!this.mercureListen.hasOwnProperty(config.uploadSmtpRelaysProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.uploadSmtpRelaysProgressStatus);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.uploadSmtpRelaysProgressStatus]: eventSource});
                }
                this.mercureListen[config.uploadSmtpRelaysProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data.fileId !== undefined) {
                        let index = this.uploadingFiles.findIndex(file => file.id === data.fileId);
                        if (index < 0) {
                            return;
                        } else {
                            this.uploadingFiles[index].completion = parseInt(data.completion) + '%';
                        }
                        if (data.error !== undefined) {
                            this.$snotify.error('File ' + this.uploadingFiles[index].label + ' processing error: ' + data.error);
                            this.uploadingFiles.splice(index, 1);
                            return;
                        }
                        if (100 === parseInt(data.completion)) {
                            this.$snotify.success('File ' + this.uploadingFiles[index].label + ' processing completed! Uploaded ' + data.createdCount + ' relays.');
                            this.uploadingFiles.splice(index, 1);
                        }
                    }
                }
            },
            loadServerList() {
                SmtpServerService.getServerSelect(this.owner.id).then(response => {
                    this.serverList = response.data['hydra:member'].map(server => {
                        return {id: server.id, label: server.name}
                    });
                });
            },
            loadGroupList() {
                SmtpRelayGroupService.getGroupSelect(this.owner.id).then(response => {
                    this.groupList = response.data['hydra:member'].map(group => {
                        return {id: group.id, label: group.name}
                    });
                });
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            listUpload() {
                let data = new FormData();
                data.append('relays', document.getElementById('relays').files[0]);
                if (this.server) {
                    data.append('serverId', this.server.id);
                }
                if (this.group) {
                    data.append('groupId', this.group.id);
                }
                SmtpRelayService.uploadRelays(data).then(response => {
                    if (response.status === 200) {
                        Swal({
                            type: 'success',
                            title: 'File is accepted for processing',
                            text: 'It will take some time to process the data, please wait.'
                        });
                        this.getUploadingFiles();
                        this.uploadCardView = false;
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Error',
                            text: response.data.error !== undefined ? response.data.error : 'Some error occurred.'
                        })
                    }
                });

            },
            ownerSelected() {
                if (this.owner !== undefined) {
                    this.loadServerList();
                    this.loadGroupList();
                } else {
                    this.serverList = [];
                    this.groupList = [];
                    this.server = null;
                    this.group = null;
                }
            }
        }
    }
</script>

<style scoped>
    .bounce-enter-active {
        animation: bounce-in .8s;
    }

    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }

    @keyframes bounce-in {
        0% {
            transform: scale(0.5);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
</style>